import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'video-popup-example',
  templateUrl: 'video-popup-example.component.html',
})
export class VideoPopupExampleComponent implements OnInit {
  initialized = false;

  @Input()
  videoLink: string;

  @Input()
  analysisName: string;

  @Input()
  description: string;

  @Input()
  encoded: boolean;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
